<template>
    <div class="tags-section">
        <div class="tags">
            <i :class="tagIcon"></i>
            <label>{{ tagHeading | capitalize }}</label>
        </div>

        <div class="tag-status">
            <span :class="tagStatusClass">
                <i :class="tagStatusIcon"></i>
            </span>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'

export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        statusType: {
            type: String,
            default: null,
        },

        tagIcon: {
            type: String,
            default: null,
        },
        tagHeading: {
            type: String,
            default: null,
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {}
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        tagStatusClass() {
            let status = _.lowerCase(this.statusType)
            if (status == 'low') {
                return 'success'
            }
            if (status == 'medium') {
                return 'warning'
            }
            if (status == 'high' || status == 'rejected') {
                return 'danger'
            }
            if (status == 'sanction') {
                return 'black'
            }
            return 'success'
        },
        tagStatusIcon() {
            let status = _.lowerCase(this.statusType)
            if (
                status == 'medium' ||
                status == 'high' ||
                status == 'sanction' ||
                status == 'low' ||
                status == 'rejected'
            ) {
                return 'icon-wrong'
            }
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
